<div *ngIf="content | async as c; else loading">
  <h3 style="margin-top:0;">{{ c.help_label }}</h3>
  <br/>
  <span [innerHTML]="c.help_text"></span>
</div>
<ng-template #loading>
  <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
    <i class="fa fa-spinner fa-pulse fa-3x"></i>
  </div>
</ng-template>
